import { BottomSheet, Text, Title, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface TimeclockHelpBottomSheetProps {
  modalState: UseModalState;
  onCancel: () => void;
  onContinue: () => void;
  isSkipTimeclockUsageEnabled: boolean;
  timeClockUsageWarning: string;
}

export function TimeclockHelpBottomSheet(props: TimeclockHelpBottomSheetProps) {
  const { modalState, onCancel, onContinue, isSkipTimeclockUsageEnabled, timeClockUsageWarning } =
    props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" onClose={onCancel}>
          <Button fullWidth variant="contained" size="large" onClick={onContinue}>
            Continue
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent sx={{ px: 5, py: 6 }}>
        <Stack spacing={6} sx={{ paddingTop: 8 }}>
          <Title semibold variant="h3" component="h3">
            Need help?
          </Title>
          <Stack spacing={4} alignItems="stretch">
            <Text variant="body1">
              If you are not able to use the workplace&apos;s time clock, please seek help from
              facility staff.{" "}
              {isSkipTimeclockUsageEnabled
                ? "If you still can't resolve the problem, please record a selfie video in front of the time clock explaining why you cannot use it."
                : ""}
            </Text>
            <Text variant="body1">
              Videos will be reviewed by facility admin.{" "}
              <Text
                sx={{
                  color: (theme) => theme.palette.error.main,
                  display: "inline",
                }}
              >
                {timeClockUsageWarning}
              </Text>
            </Text>
          </Stack>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
